import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id F41863ED-B66A-4FF4-B436-0876C8D3665B
 * name thermometer
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/thermometer.svg
 * tags
 * - Weather 
 * - Home Automation 
 * - Automotive 
 */
export const ThermometerIcon = createSvgIcon(<><path d="M15 13V5A3 3 0 0 0 9 5V13A5 5 0 1 0 15 13M12 4A1 1 0 0 1 13 5V8H11V5A1 1 0 0 1 12 4Z" /></>, 'ThermometerIcon');
export default ThermometerIcon